(function(){
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  const SWIPER_EVENT = 'loomish-swiper-loaded';

  function loadSwiperAssets(callback){
    if(window.Swiper){ callback(); return; }
    if(window.__loomishSwiperLoading){
      document.addEventListener(SWIPER_EVENT, callback, { once: true });
      return;
    }
    window.__loomishSwiperLoading = true;
    const script = document.createElement('script');
    script.src = SWIPER_JS;
    script.async = true;
    script.addEventListener('load', function(){
      window.__loomishSwiperLoading = false;
      document.dispatchEvent(new Event(SWIPER_EVENT));
      callback();
    });
    document.head.appendChild(script);
  }

  function destroySlider(section){
    if(!section) return;
    const swiper = section._loomishSwiper;
    if(swiper && typeof swiper.destroy === 'function'){
      swiper.destroy(true, true);
    }
    section._loomishSwiper = null;
    if(section._lsaRest){ section._lsaRest.disconnect(); section._lsaRest = null; }
    if(section._lsaVis){ document.removeEventListener('visibilitychange', section._lsaVis); section._lsaVis = null; }
  }

  function getSectionById(sectionId){
    return sectionId ? document.querySelector('#shopify-section-' + sectionId) : null;
  }

  /* Disable pointer events on the deep off-centre slides so only the visible
   * coverflow cards are interactive. Every slide stays fully OPAQUE — the row is
   * continuous edge-to-edge and clipped by the container's overflow:hidden.
   * (No more --vis opacity fade, which used to create the gap; no --dark scrim.) */
  function updateDepthFx(swiper){
    if(!swiper || !swiper.slides) return;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i++){
      var sl = slides[i];
      var ap = Math.abs(sl.progress || 0);
      sl.style.pointerEvents = ap > 3.5 ? 'none' : '';
    }
  }

  function initSlider(section){
    if(!section || !section.classList.contains('loomish-slider-ad')) return;
    if(section._loomishSwiper){ destroySlider(section); }

    const container = section.querySelector('.loomish-slider-ad__swiper');
    const slides = section.querySelectorAll('.swiper-slide');
    if(!container || slides.length === 0) return;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) * 1000 || 4000;
    const transitionSpeed = Number(section.dataset.transitionSpeed) || 850;
    // Clamp depth + neighbour scale so the fan stays CONNECTED (gentle even falloff).
    // Lower depth = less perspective shrink/displacement; higher scale floor = outer
    // slides stay substantial instead of collapsing into gaps.
    var depthRaw = Number(section.dataset.depth) || 120;
    const depth = Math.min(Math.max(depthRaw, 90), 150);
    var nScaleRaw = Number(section.dataset.neighborScale) ? Number(section.dataset.neighborScale) / 100 : 0.86;
    const neighborScale = Math.min(Math.max(nScaleRaw, 0.84), 0.90);
    const showArrows = section.dataset.showArrows === 'true';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = autoplayEnabled && !prefersReduced;
    const slideCount = slides.length;
    const loop = slideCount > 1;

    // Gap is an additive delta so 0 reproduces the tuned coverflow overlap exactly.
    const gapDelta = Number(section.dataset.gap) || 0;
    const isMobileVp = window.matchMedia('(max-width: 640px)').matches;

    // 3D angle: a new control that defaults strong (40deg) so neighbours read as a
    // clear angled fan even on existing instances (new settings fall back to default).
    var cfAngleRaw = Number(section.dataset.cfIntensity);
    if (isNaN(cfAngleRaw)) cfAngleRaw = 40;
    // Cap rotate so outer slides never approach edge-on (which made them razor-thin
    // and detached). 36deg keeps a clear tilt while staying connected.
    const cfRotate = prefersReduced ? 0 : (isMobileVp ? Math.min(cfAngleRaw, 24) : Math.min(cfAngleRaw, 36));
    const cfDepth = prefersReduced ? 80 : (isMobileVp ? 90 : depth);

    // Compact, fan-like sizing. slidesPerView:'auto' reads each slide's CSS width.
    // We CAP the card relative to the visible track so the centre never dominates
    // and ~2.5 slides show — regardless of the saved Slide width value.
    // Height drives the size (4:5 -> width = height * 0.8). Cap to the viewport
    // height so the slider stays sleek and full-page without overflowing.
    const cssOf = getComputedStyle(section);
    const savedH = parseInt(cssOf.getPropertyValue('--slide-h'), 10) || 560;
    const savedHm = parseInt(cssOf.getPropertyValue('--slide-h-mobile'), 10) || 420;
    const vh = window.innerHeight || 800;
    // Compact like the target: centre height ~475 -> width ~380 (locked 4:5).
    // A phone held sideways is a short screen on the wide branch: a 360px
    // floor put cards taller than the whole window, cut by the bar. Below
    // 560px of height the card is sized from the screen instead, so the
    // rail and its reflection are seen whole. Taller windows are unchanged.
    const short = vh < 560;
    const cardH = short
      ? Math.max(180, Math.min(savedH, Math.round(vh * 0.56)))
      : Math.max(360, Math.min(savedH, Math.round(vh * 0.62), 500));
    const cardHm = Math.max(280, Math.min(savedHm, Math.round(vh * 0.50), 500));
    section.style.setProperty('--slide-h', cardH + 'px');
    section.style.setProperty('--slide-h-mobile', cardHm + 'px');
    const cardWDesktop = Math.round(cardH * 0.8);
    const cardWMobile = Math.round(cardHm * 0.8);
    // Tighter base overlap so the constant layout pitch can't open gaps as slides recede.
    const overlapDesktop = Math.round(-0.34 * cardWDesktop) + gapDelta;
    const overlapMobile = Math.round(-0.30 * cardWMobile) + gapDelta;
    // Negative coverflow stretch pulls each receding slide INWARD in proportion to its
    // distance, so adjacent slides keep overlapping (no floating outer slides).
    const cfStretch = prefersReduced ? 0 : -Math.round((isMobileVp ? cardWMobile : cardWDesktop) * 0.10);

    // The old floor of 820ms silently discarded whatever was set in the editor,
    // so a saved 300 still ran at 820 and the rail felt heavy. Expensive is not
    // the same as slow: the quality is in the easing curve, not the duration.
    // The floor now only guards against a value low enough to look broken.
    const smoothSpeed = prefersReduced
      ? Math.max(240, Math.round(transitionSpeed * 0.6))
      : Math.min(Math.max(transitionSpeed, 260), 1100);

    const config = {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      loopAdditionalSlides: 5,
      observer: true,
      observeParents: true,
      speed: smoothSpeed,
      spaceBetween: overlapMobile,

      /* ── FEEL ──────────────────────────────────────────────────────────
         threshold 5 meant the rail ignored the first 5px of every drag, so
         it read as a beat of lag before anything moved. 2 is the smallest
         value that still rejects an accidental twitch.

         resistanceRatio lower = less rubber at the ends: the rail tracks
         the finger instead of arguing with it.

         longSwipesRatio 0.5 required dragging a slide HALF its width to
         advance. At 0.2 a short flick is enough, which is how a rail this
         size actually gets used.

         touchAngle 35 (from 45) lets a mostly-vertical swipe scroll the
         page instead of being captured - the single biggest cause of a
         carousel feeling like it is fighting you on a phone. */
      threshold: 2,
      resistanceRatio: 0.62,
      touchRatio: 1.12,
      touchAngle: 35,
      longSwipesRatio: 0.2,
      followFinger: true,
      watchSlidesProgress: true,
      /* Click a card either side and it comes to the centre. The cover link
         on non-active slides is made inert in CSS, so a side click only ever
         steers - it can never fire a navigation you did not mean. */
      slideToClickedSlide: true,
      breakpoints: {
        641: {
          spaceBetween: overlapDesktop
        }
      },
      coverflowEffect: {
        rotate: cfRotate,
        stretch: cfStretch,
        depth: cfDepth,
        modifier: 1,
        scale: prefersReduced ? 0.96 : neighborScale,
        slideShadows: false
      },
      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}'
      },
      on: {
        init() {
          if(prefersReduced && this.autoplay){
            this.autoplay.stop();
          }
          updateDepthFx(this);
        },
        setTranslate() { updateDepthFx(this); },
        resize() { updateDepthFx(this); }
      }
    };

    if(showArrows){
      config.navigation = {
        nextEl: section.querySelector('.loomish-slider-ad__nav--next'),
        prevEl: section.querySelector('.loomish-slider-ad__nav--prev')
      };
    }

    const swiper = new Swiper(container, config);
    section._loomishSwiper = swiper;
    swiper.update();

    // Load-in: fade + rise the slider once (CSS handles the keyframe; reduced-motion disables it).
    requestAnimationFrame(function(){ section.classList.add('is-init'); });
    window.addEventListener('load', function() { if(swiper) swiper.update(); }, { once: true });

    /* The rail turns only while someone can see it. Both rails on the home
       page used to turn every four seconds for the whole visit - 3D cards
       re-laid out on a phone while its owner was reading Kazak two thousand
       pixels further down, and in a tab nobody was looking at. Coming back
       into view it picks up where it was left. */
    if(autoplay && swiper.autoplay){
      var seen = true;
      var rest = function(){
        if(!swiper || swiper.destroyed || !swiper.autoplay) return;
        var go = seen && !document.hidden && !section._lsaHeld;
        if(go && !swiper.autoplay.running) swiper.autoplay.start();
        else if(!go && swiper.autoplay.running) swiper.autoplay.stop();
      };
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          seen = entries[entries.length - 1].isIntersecting;
          rest();
        }, { rootMargin: '120px 0px' });
        io.observe(section);
        section._lsaRest = io;
      }
      var onVis = function(){ rest(); };
      document.addEventListener('visibilitychange', onVis);
      section._lsaVis = onVis;
    }
    // Hover pause is handled natively by autoplay.pauseOnMouseEnter — no manual stop
    // (the manual stop used to freeze the slider in the editor preview).
  }

  /* A phone with the gallery engine never downloads Swiper: assets/loomish-rail.js
     owns the slider there. Turned sideways past 749px it becomes a coverflow,
     and back again - each engine is taken down before the other starts. */
  const narrow = window.matchMedia('(max-width: 749px)');
  function railHere(section){
    return section.getAttribute('data-phone-engine') === 'rail' && narrow.matches;
  }

  function initIfMine(root){
    if(!root) return;
    const section = root.classList && root.classList.contains('loomish-slider-ad') ? root : root.querySelector('.loomish-slider-ad');
    if(!section) return;
    if(railHere(section)) return;
    loadSwiperAssets(function(){ if(!railHere(section)) initSlider(section); });
  }

  const onWidth = function(){
    document.querySelectorAll('.loomish-slider-ad[data-phone-engine="rail"]').forEach(function(section){
      if(narrow.matches){
        destroySlider(section);
        if(window.LoomishRail) window.LoomishRail.scan(section.parentNode || document);
      } else {
        if(section.__lsaRail) section.__lsaRail.destroy();
        initIfMine(section);
      }
    });
  };
  if(narrow.addEventListener) narrow.addEventListener('change', onWidth);
  else if(narrow.addListener) narrow.addListener(onWidth);

  function destroyIfMine(root){
    if(!root) return;
    const section = root.classList && root.classList.contains('loomish-slider-ad') ? root : root.querySelector('.loomish-slider-ad');
    destroySlider(section);
  }

  function slideToBlock(event){
    const section = getSectionById(event.detail && event.detail.sectionId);
    const blockId = event.detail && event.detail.blockId;
    if(!section || !blockId) return;
    const swiper = section._loomishSwiper;
    if(!swiper) return;
    const slides = Array.from(section.querySelectorAll('.swiper-slide'));
    const targetIndex = slides.findIndex((slide) => slide.dataset.blockId === blockId);
    if(targetIndex >= 0){
      swiper.slideToLoop(targetIndex);
      section._lsaHeld = true;
      if(swiper.autoplay && swiper.autoplay.running){
        swiper.autoplay.stop();
      }
    }
  }

  function resumeAutoplay(event){
    const section = getSectionById(event.detail && event.detail.sectionId);
    if(!section) return;
    const swiper = section._loomishSwiper;
    section._lsaHeld = false;
    if(swiper && swiper.autoplay && section.dataset.autoplay === 'true'){
      swiper.autoplay.start();
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.loomish-slider-ad').forEach(initIfMine);
  });

  document.addEventListener('shopify:section:load', function(event){ initIfMine(event.target); });
  document.addEventListener('shopify:section:unload', function(event){ destroyIfMine(event.target); });
  document.addEventListener('shopify:block:select', slideToBlock);
  document.addEventListener('shopify:block:deselect', resumeAutoplay);
})();
